module.exports = __webpack_public_path__ + "static/media/Group8.44a7fbcb.png";